import states from "./mapData.json";
import styles from "./mapStyles.json";

document.addEventListener("DOMContentLoaded", async () => {
  const { Map, InfoWindow } = await google.maps.importLibrary("maps");
  const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

  // Create map.
  const gmapElements = document.querySelectorAll(".gmap");
  gmapElements.forEach((gmapElement) => {
    // Map Data.
    const zoom = JSON.parse(gmapElement.dataset.zoom);
    const center = JSON.parse(gmapElement.dataset.center);
    const statesData = JSON.parse(gmapElement.dataset.states);
    states.features = states.features.filter((value) => statesData.includes(value.properties.name));
    const addressData = JSON.parse(gmapElement.dataset.locations);
    const styledMapType = new google.maps.StyledMapType(styles);

    // Map setup.
    const gmap = new Map(gmapElement, {
      mapId: "6824416cf1174dac67fd18e7",
      center: { lat: Number(center["lat"]), lng: Number(center["lng"]) },
      zoom: Number(zoom),
      gestureHandling: "cooperative",
      disableDefaultUI: true,
      mapTypeControlOptions: {
        mapTypeIds: ["styled_map"],
      },
    });
    gmap.mapTypes.set("styled_map", styledMapType, { name: "Styled Map" });
    gmap.setMapTypeId("styled_map");
    gmap.data.addGeoJson(states);
    gmap.data.setStyle({
      fillColor: "#8BBDE7",
      fillOpacity: 0.5,
      strokeColor: "#8BBDE7",
      strokeWeight: 1,
      strokeOpacity: 0.8,
    });

    // Map markers.
    const infoWindow = new InfoWindow({ maxWidth: 400 });
    addressData.map((data) => {
      const markerElement = document.createElement("div");
      if (data.icon) {
        const applyMaskedIconStyles = (element, inset, color) => {
          element.style.position = "absolute";
          element.style.inset = inset;
          element.style.backgroundColor = color;
          element.style.maskImage = `url("${data.icon}")`;
          element.style.webkitMaskImage = `url("${data.icon}")`;
          element.style.maskRepeat = "no-repeat";
          element.style.webkitMaskRepeat = "no-repeat";
          element.style.maskPosition = "center";
          element.style.webkitMaskPosition = "center";
          element.style.maskSize = "contain";
          element.style.webkitMaskSize = "contain";
        };
        markerElement.style.position = "relative";
        markerElement.style.width = "26px";
        markerElement.style.height = "26px";
        const outlineElement = document.createElement("span");
        applyMaskedIconStyles(outlineElement, "0", "#000");
        const iconElement = document.createElement("span");
        applyMaskedIconStyles(iconElement, "1px", data.color);
        markerElement.append(outlineElement, iconElement);
      } else {
        markerElement.className = "size-4 border-white border-2 rounded-full";
        markerElement.style.backgroundColor = data.color;
      }

      const markerTitle = document.createElement("div");
      markerTitle.className = "text-xl font-bold text-primary";
      markerTitle.textContent = data.title;
      markerTitle.style.maxWidth = "400px";
      markerTitle.style.padding = "2px 2px 0";

      const markerContent = document.createElement("div");
      markerContent.className = "text-black";
      markerContent.innerHTML = data.image + data.content;
      markerContent.style.maxWidth = "400px";
      markerContent.style.padding = "2px 2px 2px 6px";

      const marker = new AdvancedMarkerElement({
        map: gmap,
        title: data.title,
        position: data.address,
        content: markerElement,
        gmpClickable: true,
      });

      marker.addListener("click", () => {
        infoWindow.close();
        infoWindow.setHeaderContent(markerTitle);
        infoWindow.setContent(markerContent);
        google.maps.event.addListenerOnce(infoWindow, "domready", () => {
          if (typeof window.clpeInitCarousels === "function") {
            window.clpeInitCarousels(markerContent);
          }
        });
        infoWindow.open(marker.map, marker);
      });
    });
  });
});
